import { render, staticRenderFns } from "./FriendAddDialog.vue?vue&type=template&id=5ad0ef0b"
import script from "./FriendAddDialog.vue?vue&type=script&lang=js"
export * from "./FriendAddDialog.vue?vue&type=script&lang=js"
import style0 from "./FriendAddDialog.vue?vue&type=style&index=0&id=5ad0ef0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.2__lodash@4_9acdcff83b5891d2d7c120609da332e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports